import { useEffect, useState } from 'react';

const readThemeColors = () => {
  const style = getComputedStyle(document.documentElement);
  const read = (name) => style.getPropertyValue(name).trim();
  return {
    accent: read('--color-primary'),
    accentContrast: read('--button-primary-text'),
  };
};

const useThemeColors = () => {
  const [colors, setColors] = useState(readThemeColors);

  useEffect(() => {
    const observer = new MutationObserver(() => setColors(readThemeColors()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    return () => observer.disconnect();
  }, []);

  return colors;
};

export default useThemeColors;
